import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = [
    'details',
    'collectionSelect'
  ];

  toggleDetails() {
    const details = this.detailsTarget;
    if (details && this.hasCollectionSelectTarget) {
      if (!details.open) {
        this.collectionSelectTarget.selectedIndex = 0;
      }
    }
  }
}